import update from 'immutability-helper';

export default function setGettingFeedData(state, action) {
  // console.log('SET_GETTING_FEED_DATA', action)

  return update(state, {
    gettingFeed: {
      $set: true,
    },
  });
}
